import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import BoardUser from "./components/board-user.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";
import Alerts from "./components/alerts.component";
import AlertsPage from "./components/alerts-page.component";
import ShortList from "./components/shortList.component";
import ConfigPage from "./components/ConfigPage.component";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./ui/styles/mobile.css";
import Applayout from "./ui/Applayout.component";
import ProtectedRoute from "./ui/ProtectedRoute.component";
import NoAuthLayout from "./ui/uiElements/NoAuthLayout.component";
import RegistrationRequests from "./components/RegistrationRequests.component";
import Users from "./components/Users.component";
import Invite from "./components/Invite.component";
import ProtectedAdmin from "./ui/ProtectedAdmin.component";
import ProtectedBotView from "./ui/ProtectedBotView.component";
import ErrorPage from "./ui/ErrorPage.component";
import TardeJournal from "./components/TardeJournal.component";
import AddTrade from "./ui/AddTrade.component";
import AllTrades from "./ui/AllTrades.component";
import TradeDetails from "./ui/TradeDetails.component";
import TickerTrades from "./ui/TickerTrades.component";
import AlertCharts from "./components/AlertCharts";
import AgentStatus from "./components/AgentStatus.component";
import Observability from "./components/Observability.component";
import BotTrades from "./components/BotTrades.component";
import Agents from "./components/Agents.component";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <Applayout />
            </ProtectedRoute>
          }
        >
          <Route index path="/home" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user" element={<BoardUser />} />
          <Route path="/mod" element={<BoardModerator />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdmin>
                <BoardAdmin />
              </ProtectedAdmin>
            }
          >
            <Route index path="/admin/users" element={<Users />} />
            <Route path="/admin/registrationRequests" element={<RegistrationRequests />} />
            <Route path="/admin/invitation" element={<Invite />} />
          </Route>
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/alertspage" element={<AlertsPage />} />
          <Route path="/shortList" element={<ShortList />} />
          <Route path="/configAlerts" element={<ConfigPage />} />
          <Route path="/charts" element={<AlertCharts />} />
          <Route
            path="/agent"
            element={
              <ProtectedBotView>
                <AgentStatus />
              </ProtectedBotView>
            }
          />
          <Route
            path="/observability"
            element={
              <ProtectedBotView>
                <Observability />
              </ProtectedBotView>
            }
          />
          <Route
            path="/bot-trades"
            element={
              <ProtectedBotView>
                <BotTrades />
              </ProtectedBotView>
            }
          />
          <Route
            path="/agents"
            element={
              <ProtectedBotView>
                <Agents />
              </ProtectedBotView>
            }
          />
          <Route path="/trade-journal" element={<TardeJournal />}>
            <Route index path="/trade-journal/all-trades" element={<AllTrades />} />
            <Route path="/trade-journal/add-trade" element={<AddTrade />} />
            <Route path="/trade-journal/:id" element={<TradeDetails />} />
            <Route path="/trade-journal/trade-ticker/:tickerName" element={<TickerTrades />} />
          </Route>
        </Route>
        <Route element={<NoAuthLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
        </Route>
        <Route path="*" element={<ErrorPage errorCode="404" description="Page Not Found" />} />
      </Routes>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 3000,
          },
          style: {
            fontSize: "16px",
            maxWidth: "500px",
            padding: "16px 24px",
            backgroundColor: "white",
            color: "black",
          },
        }}
      />
    </QueryClientProvider>
  );
};

export default App;
